import React from 'react';
import $ from 'jquery';
import PreloginHome from '../../prelogin/src/PreloginHome';
import { slide as Menu } from 'react-burger-menu';
import { BrowserRouter as Router, Link, Redirect, Route, Switch } from "react-router-dom";
import BrowserUtil from '../../util/BrowserUtil';
import UserStorageUtil from '../../util/UserStorageUtil';
import sidebar_props from '../../model/AppConstants.js';

import ScrollToTopOnMount from '../../prelogin/src/components/ScrollToTopOnMount.js';
import Banner from './sg_Banner.js';
import RecognisedStatic from '../../prelogin/src/components/RecognisedStatic';
import LessonFeatures from '../../prelogin/src/components/LessonFeatures.js';
import OurTeachers from '../../prelogin/src/components/OurTeachers';
import StaticFeed from '../../prelogin/src/components/StaticFeed';
import SignupSection from './sg_SignupSection.js';
import UnifiedForgotPwd from './sg_UnifiedForgotPwd';
import Footer from './sg_Footer';
import UnifiedLogin from './sg_UnifiedLogin';
import SignupForm from './sg_SignupForm';
import ComponentRegistry from '../../model/ComponentRegistry.js';
import Home from '../../views/plp/Home';
import Dashboard from '../../views/dashboard/Dashboard';
import Scorecard from '../../views/scorecard/Scorecard';

import HmEventRegistry from '../../model/HmEventRegistry';
import PageBanner from '../../prelogin/src/components/PageBanner.js';
import FlipSection from '../../prelogin/src/components/FlipSection.js';
import OtherLearnings from '../../prelogin/src/components/OtherLearnings.js';
import EndorsedStatic from '../../prelogin/src/components/EndorsedStatic';
import NrichCollaboration from '../../prelogin/src/components/NrichCollaboration';
import WhoBanner from '../../prelogin/src/components/WhoBanner2.js';
import DayInLife from '../../prelogin/src/components/DayInLife.js';
import Culture from '../../prelogin/src/components/Culture.js';
import Founders from '../../prelogin/src/components/Founders.js';
import OurTeam from '../../prelogin/src/components/OurTeam.js';
import FounderVideos from '../../prelogin/src/components/FounderVideos.js';
import Recognised from '../../prelogin/src/components/Recognised.js';
import TopBanner from './../../views/others/TopBanner';
import OverallFeatures from '../../prelogin/src/components/OverallFeatures';
import SGProductCatalogue from './../../views/others/SGProductCatalogue';
import FAQ from '../../prelogin/src/components/FAQ';
import BillingDetails from '../../views/purchase/BillingDetails';
import MyProducts from '../../views/purchase/MyProducts';

class sg_PreloginHome extends PreloginHome{

 	constructor(props) {
         super(props);
         this.showHideLeftMenu = this.showHideLeftMenu.bind(this);

         this.getHeaderLogo = this.getHeaderLogo.bind(this);
     }
     
     componentWillMount(){		
        super.componentWillMount(); 
     }

     componentDidMount() {	 
        //console.warn("PreloginHome SG");
         super.componentDidMount();
                
              this.setFavIco(); 
			
            try{
                var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");
  
                //UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
              sidebar_props.collapsed = isCollapsed ||  sidebar_props.collapsed;
  
              if(sidebar_props.collapsed === true){
                  $('.side-navbar').addClass('shrinked');
                  $('.content-inner').addClass('active');
                  $('#toggle-btn').removeClass('active');
                  $('#toggle-btn').removeClass("goRight");
                  $('.navbar-header .brand-small').show();
                  $('.navbar-header .brand-big').hide();
              }
          }catch(e){
              console.error(e);
          }
  
            if ($(window).outerWidth() > 1183) {
              if ($('#toggle-btn').hasClass('active')) {             
                  $('#toggle-btn').addClass("goRight");
              } else {             
                  $('#toggle-btn').removeClass("goRight");
              }
          }
          if ($(window).outerWidth() < 1183) {         
              $('#toggle-btn').removeClass("goRight");
          }

        this.appendCSS("./vendors/sg_main.css");
    }

    /**
    * IMPORTANT: Please follow this way to use favIcon
    */
    setFavIco(){
         if(window.fav_ico_by_prefix && window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()]){
            if(document.getElementsByName("fav_ico").length > 0){
              document.getElementsByName("fav_ico")[0].href=window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()];
            }
         } 
    }
  
    toggleSideBar(){
        $('#toggle-btn').toggleClass('active');
  
          $('.side-navbar').toggleClass('shrinked');
          $('.content-inner').toggleClass('active');
          if ($(window).outerWidth() > 1183) {
              if ($('#toggle-btn').hasClass('active')) {
                  $('.navbar-header .brand-small').hide();
                  $('.navbar-header .brand-big').show();
                  $('#toggle-btn').addClass("goRight");
              } else {
                  $('.navbar-header .brand-small').show();
                  $('.navbar-header .brand-big').hide();
                  $('#toggle-btn').removeClass("goRight");
              }
          }
  
          if ($(window).outerWidth() < 1183) {
              $('.navbar-header .brand-small').show();
              $('#toggle-btn').removeClass("goRight");
          }
  
          try{
              var isCollapsed = $('.side-navbar').hasClass('shrinked');
  
  
              if(typeof isCollapsed === "boolean"){
                  this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
              }
              
  
              sidebar_props.collapsed =  $('.side-navbar').hasClass('shrinked');
              UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);
          }catch(e){
              console.log(e);
          }

          try{
            var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");
            console.log("isCollapsed::::",isCollapsed);
            //UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
          sidebar_props.collapsed = isCollapsed ||  sidebar_props.collapsed;

          if(sidebar_props.collapsed === true){
              $(".page-content .content-inner").toggleClass("fullwidth");
              $(".page-content nav.side-navbar").toggle();
              $(".page-content nav.side-navbar").toggleClass('collapsed');
          }
        }catch(e){
            console.error(e);
        }
        }
      

    getButtonName(){
        //console.log("lumos login::::",this.state.LumosloggedIn);
        if(this.state.loggedIn || this.state.LumosloggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5) || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
            //return this.rb("menu.home");
            return this.rb("btn.label.myheymath");
        }
        return this.rb("btn.label.signin");
    }

    Home = () => {
        if(!this.tracked){
            this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"home-PageView"});
            this.tracked = true;
        }

        try{
            if(this.state.LumosloggedIn){
                window.location.href = this.getUrlFor("LUMOS_REDIRECT_URL");
            }else if(this.state.PLPloggedIn && !window.location.href.match("/home")){
                window.location.href = "/landing";
            }
        }catch(e){}

        this.selectedMenu = "menuhome";
        var me=this;
        return(
            <div>
            {me.setTitle("HOME_title")}
            {me.setMeta("HOME_meta")}
            {me.setHeading("HOME_heading")}
            <div id="bannerElement">{this.getBannerContent()}</div>
            <ScrollToTopOnMount/>
            <Banner products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()} PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></Banner>
            <RecognisedStatic></RecognisedStatic>
            <LessonFeatures></LessonFeatures>
            <OurTeachers></OurTeachers>
            <StaticFeed></StaticFeed>
            <SignupSection PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></SignupSection>
            <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
            {this.fireMobileToast()}
            </div>
        );
    }
      /*
      * IMPORTANT: Hardcoded temporarily. Needs to be addressed post demo
      */       
       getHeaderLogo(){
        if(this.getUser().getSchoolPrefix() && this.getUser().getSchoolPrefix().length > 0){
          if(this.getUser().getSchoolPrefix().toLowerCase() === "ms_"){
              return(
              <img src="/img/mindstretcher/logo.png" alt="Mind Stretcher logo"/>
          )
          }else{
            return super.getHeaderLogo();  
          }
        }else{
          return super.getHeaderLogo();  
        }
       } 

       

       renderLoginView = () => {
           
        if(this.state.loggedIn == true){
            //console.warn("this.UserStore ",this.UserStore);
    return(
         <div className="inlineblock">
    
    <div className="inlineblock navbar-nav">
     <li className="nav-item dropdown">
     <div className="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
   
    { this.state.imageLoaded ? <img className="material-icons md-60  usericon imgprv" src={ this.state.imagePreviewUrl} /> : <i className="material-icons md-40 useraccountelement">account_circle</i> }
    </div>
    <div className="dropdown-menu">
    {/* <div className="dropdown-item pflename">{this.UserStore.getUserName() || this.UserStore.getLoginId()}</div> */}
    <a className={"dropdown-item"} href="/myproducts" data-ga="Home - My Subscriptions"><i className="material-icons pr-16">credit_card</i> My Subscriptions</a>
    <a className="dropdown-item" href="/settings" ><i className="material-icons pr-16">account_circle</i> My Profile</a>
    <a className="dropdown-item" href="#" onClick={() => {this.onLogout()}}><i className="material-icons pr-16">power_settings_new</i> Sign out</a>
    </div>
    </li>
    </div>
    </div>
    );
    }
    }  

    getUnifiedLoginForm(loginType=null,userid=null,errMsg=null){
        return ( 
        <div>                   
        <div className="row">                                   
        <div className="col-12 nopadding">
        <UnifiedLogin myProps={this.props} loginType={loginType} userid={userid} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={'/products'} errMsg={errMsg}/>
        </div>
        <br/>
        </div>
        </div>
        );
    }

    getVerifyAccount(loginType=null,userInput=null,navigateurl=null,freetrail=null){
        if(navigateurl == null){
            navigateurl = '/products';
        }
        return(				
        <SignupForm signupUser={'student'} myProps={this.props} loginType={loginType} data-ga={this.modalcloseDataGA} userInput={userInput} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL={navigateurl} freetrail={freetrail} gaFrom={this.gaFrom} />
        );
    }

    getForgotPassword(source){
        return ( 
        <div>                   
        <div className="row">
        <div className="col-12 nopadding">
        <UnifiedForgotPwd myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage} showNewLoginForm={this.showNewLoginForm}/>
        </div>      
        </div>
        </div>
        );
    }

    getUnifiedLoginFormWithoutNav(loginType=null,userid=null,errMsg=null, navUrl = null, callBack=null){
        return ( 
        <div>                   
        <div className="row">                                   
        <div className="col-12 nopadding">
        <UnifiedLogin myProps={this.props} loginType={loginType} userid={userid} callBack={callBack} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={navUrl} errMsg={errMsg}/>
        </div>
        <br/>
        </div>
        </div>
        );
    }

    postLoginTchr(userObj){
      var me = this;
      if(!userObj){
        userObj = this.getUser().get();
      }
      
      return(
        <ul className="textAlignLeft">
        { this.sgProductTab() }
      </ul>
      )

    //    if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR") {
    //       return (
    //         <ul className="textAlignLeft">
    //           <li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
    //         </ul> 
    //       );
    //     }else{ 
    //       return (
    //         <ul className="textAlignLeft">
    //           { this.sgProductTab() }
    //         </ul>
    //       );
    //     }
    }

    postLoginTchrTab(userObj){
      var me = this;
      if(!userObj){
        userObj = this.getUser().get();
      }

      return (
        <ul className="textAlignLeft">
          { this.sgProductTab() }
        </ul>
      );

    //    if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR") {
    //       return (
    //         <ul className="textAlignLeft">
    //           <li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
    //         </ul> 
    //       );
    //     }else{ 
    //       return (
    //         <ul className="textAlignLeft">
    //           { this.sgProductTab() }
    //         </ul>
    //       );
    //     }
    }
   
    getSingleLoginForm(event){

        let loginSource = event.currentTarget.dataset.source || '';

        if(loginSource == "" || loginSource == "lumos" || loginSource == "plp"){
            this.modalcloseDataGA = "Home - Users who have independently registered - Close";
            this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
        }else if(loginSource == "register"){
            this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
            this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
        }
    }

    getSwitcher(){
        return(
        <Switch>
        <Redirect from="/" exact to="/sg"/>

        <Route exact path='/sg' component={this.Home}  maintainScrollPosition={true}/>
        <Route exact path='/home' component={this.Home}  maintainScrollPosition={true}/>
        <Route path="/landing" exact component={Home} />
        <Route path="/dashboard" exact component={Dashboard} />
        <Route path="/settings" exact component={this.GetMyProfile}/>
        <Route path="/scorecard/:id/:reset?" exact component={Scorecard} />
        <Route path='/our-learnings' component={this.Learnings} maintainScrollPosition={true}/>
        <Route path='/who-we-are' component={this.WhoWeAre} maintainScrollPosition={true}/>
        <Route path='/blog' component={this.Blog} maintainScrollPosition={true}/>
        <Route path='/spotlight' component={this.Spotlight} maintainScrollPosition={true}/>
        <Route path="/faq" component={this.Faq} maintainScrollPosition={true} />
        <Route exact path='/product-details' component={this.GetProductDetails} maintainScrollPosition={true}/>
                
        <Redirect from="/products" exact to={this.getGeo()+"/products"}/>

        <Route path='/in/products' component={this.newINCatalogue}  maintainScrollPosition={true}/>
        <Route exact path='/sg/products' component={this.SGCatalogue} maintainScrollPosition={true}/> 
        
        <Redirect from="/myproducts" to="/mysubscriptions"/>
        <Route path="/mysubscriptions" exact component={this.GetMyProducts} maintainScrollPosition={true}/>
    {/* 
    <Route path="/report" exact component={Report} />
    <Redirect from="/classes" to="/products"/>
    <Route path='/products' component={this.Products}  maintainScrollPosition={true}/>
    <Route path='/our-learnings' component={this.Learnings} maintainScrollPosition={true}/>
    <Route path='/who-we-are' component={this.WhoWeAre} maintainScrollPosition={true}/>
    <Route path='/blog' component={this.Blog} maintainScrollPosition={true}/>
    <Route path='/spotlight' component={this.Spotlight} maintainScrollPosition={true}/>
    <Route path="/faq" component={this.Faq} maintainScrollPosition={true} />
    <Route path='/self-learning/:id' component={this.SelfPaced} maintainScrollPosition={true}/>
    <Route path='/personalised-learning/:id' component={this.Plp} maintainScrollPosition={true}/>
    <Route path='/cbse-exam/:id' component={this.cbse} maintainScrollPosition={true}/>
    <Route exact path='/product-details' component={this.GetProductDetails} maintainScrollPosition={true}/>
    <Route exact path='/teachers' component={this.Teachers} maintainScrollPosition={true}/>
     */}
    <Route exact path="/404" component={this.Home} />
    <Route component={this.Home} />
    <Redirect from='*' to='/' />
    </Switch>
    )
    }

    getRouter(){
        var me=this;
    
        return(
        <Router>
        <div>
        <header className="clearfix">
    {/* <ContactHeader></ContactHeader> */}
    <nav className="nav-desktop">
    <div className="container-fluid norightpadding">
    <div className="logo"><Link className="heyMenu menuhome" data-classname="menuhome" to="/home" onClick={me.setPreloginClass}>{this.getHeaderLogo()}</Link></div>
    
    
    {( () => {
        if(me.state.LumosloggedIn){
            return (<ul className="textAlignLeft"><span></span></ul>);
        }else if(me.state.loggedIn || me.state.PLPloggedIn){
            return (			
                 <div>
                    {(() => {
                            if(me.isHeaderMenuAllowed("products")){
                                    return me.postLoginTchr();
                            }else{
                                    return (<ul className="textAlignLeft"><span></span></ul>);                                        
                            }
                    })()}
                </div>
            );
        }else{
            return (
            <ul>
                <li data-ga="Home Tab" ><Link className="heyMenu menuhome" data-classname="menuhome" to="/" onClick={me.menuSelected}>Home</Link></li>
                {me.sgProductTab()}
                {(() =>{
                    if(!window.teachers_tab_suppressed){
                        return <li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
                    }
                })()}
                
                {me.aboutUsTab()}
            </ul>
        );
    }
    })()}
    
    
    <div className="r-sec">
    {(() => {
                        if(me.isHeaderMenuAllowed("my_heymath")){
                            return (<a data-ga="My HeyMath Tab" className={"r-btn myheymathbtn mr-30 "+me.getMargin()} onClick={me.showLoginForm}>{me.getButtonName()}</a>);
                        }else{
                            return (<ul className="textAlignLeft"><span></span></ul>);						
                        }
                    })()}
    
    {me.renderLoginView()}                 	
    </div>
    
    
    </div>
    </nav>
    
    {
        (()=>{
    
            if(this.isHeaderMenuAllowed("hamburger")){
    
                return(
                    <Menu right onStateChange={(state) => me.handleStateChange(state)} isOpen={me.state.menuOpen}>
    
    <div id="menu-icon-wrapper" className="menu-icon-wrapper">
    </div>
    
    <nav className="nav-mobile">
    
    {( () => {
        if(me.state.loggedIn && this.isHeaderMenuAllowed("hamburger")){
            return me.postLoginTchrTab();		
        }else if(this.isHeaderMenuAllowed("hamburger")){
            return (
            <ul>
            <li data-ga="Home Tab" className="animated"><Link className="heyMenu menuhome" data-classname="menuhome" to="/" onClick={() => this.menuSelected()}>Home</Link></li>
            
            <li data-ga="SG Prducts - Main Tab" className="animated"><Link className="heyMenu menusgproducts" data-classname="menusgproducts" to="/sg/products" onClick={() => this.menuSelected()}>{this.rb("sg.products.title")}</Link></li>
            
            
            {(() =>{
                if(!window.teachers_tab_suppressed){
                    return <li data-ga="Teachers - Main Tab" className="animated"><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={() => this.menuSelected()}>Teachers</Link></li>
                }
            })()}
            
            <li data-ga="Our Learning - Main Tab" className="animated"><Link className="heyMenu menuourlearnings" data-classname="menuourlearnings" to="/our-learnings" onClick={() => this.menuSelected()}>Our Learnings</Link></li>   
        <li data-ga="Who we are - Main Tab" className="animated"><Link className="heyMenu menuwhoweare" data-classname="menuwhoweare" to="/who-we-are" onClick={() => this.menuSelected()}>Who We Are</Link></li>
    {/* <li data-ga="Blog - Main Tab" className="animated"><Link className="heyMenu menublog" data-classname="menublog" to="/blog" onClick={() => this.menuSelected()}>Blog</Link></li> */}
    <li data-ga="Spotlight - Main Tab" className="animated"><Link className="heyMenu menuspotlight" data-classname="menuspotlight" to="/spotlight" onClick={() => this.menuSelected()}>Spotlight</Link></li>
    </ul>
    );
    }
    })()}
    
    
    
    </nav>
    </Menu>
                )
    
            }else{
                return null;
            }
    
        })()
    }
    
    
    
    </header>
    <div className="clearfix"></div>
    {me.getSwitcher()}
    
    </div>
    </Router>
    )
    }

    showHideLeftMenu(){
        //$(".page-content nav.side-navbar").toggle();
        $(".page-content .content-inner").toggleClass("fullwidth");
        $(".page-content nav.side-navbar").toggle();
        $(".page-content nav.side-navbar").toggleClass('collapsed');
        
        try{
            var isCollapsed = $('nav.side-navbar').hasClass('collapsed');


            if(typeof isCollapsed === "boolean"){
                this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
            } 
            

            sidebar_props.collapsed =  $('nav.side-navbar').hasClass('collapsed');
            UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);
        }catch(e){
            //console.log(e);
        }
        
        
    }

    Learnings = () => {
        this.setTitle("LEARNINGS_title");
    
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
        this.selectedMenu = "menuourlearnings";
        return(
        <div>
        <ScrollToTopOnMount/>
    {/*<PageBanner name="Our Learnings" classes="bg-grn bg-blue banner-text" text={this.rb("our_learnings_heading")}></PageBanner>*/}
    <PageBanner classes="bg-grn bg-blue banner-text" text={this.rb("our_learnings_heading")}></PageBanner>
    <FlipSection></FlipSection>
    <OtherLearnings></OtherLearnings>
    <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
    </div>
    );
    }

    WhoWeAre = () => {
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
        this.selectedMenu = "menuwhoweare";
        var me=this;
        return(
        <div>
        {me.setTitle("WHO_WE_ARE_title")}
        {me.setMeta("WHO_WE_ARE_meta")}
        {me.setHeading("WHO_WE_ARE_heading")}
        <ScrollToTopOnMount/>
        <WhoBanner></WhoBanner>
        <DayInLife></DayInLife>
        <Culture></Culture>
        <Founders></Founders>
        <OurTeam></OurTeam>
        <FounderVideos></FounderVideos>
    {/*<ScholarsProgram></ScholarsProgram>*/}
    <Recognised></Recognised>
    <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
    </div>
    );
    }

    SGCatalogue = ({ match }) => { 
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
        this.selectedMenu = "sgproducts";
    
        if(!this.tracked){
            this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});
            this.tracked = true;
        }
    
        return(
        <div>
        <ScrollToTopOnMount/>
        <TopBanner name="CBSE Exam Prep" showContactus={this.showContactusForTeacher} triedFree={this.state.triedFree} purchased={this.state.purchased} classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams" id={`${match.params.id}`} showSubScripeLoginForm={this.showSubScripeLoginForm} productBase="cbse" simpleform="true" />
        <OverallFeatures name="PLP"></OverallFeatures>
        <SGProductCatalogue showSubscriptionForm={this.showSubscriptionForm} postLoginCallBack={this.postLoginCallBack} />
        <EndorsedStatic></EndorsedStatic>
        <NrichCollaboration></NrichCollaboration>
        {/*<SGTeacherBuy showContactus={this.showContactusForTeacher}></SGTeacherBuy>*/}
        <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
        </div>
    );
    }

    Faq = () => {
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
        //this.selectedMenu = "menufaq";
        return(
            <div>
            <FAQ/>
            <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
            </div>
            );
    }

    GetProductDetails = ({ match }) => (
        <div className="heyPrelolgin">
        <BillingDetails myProps={this.props}  purchaseKey={this.state.purchaseKey} />
        <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
        </div>
        )

    GetMyProducts = ({ match }) => (
    <div className="heyPrelolgin">
    <MyProducts myProps={this.props}  PLPloggedIn={this.state.PLPloggedIn} purchaseKey={this.state.purchaseKey} showSubScripeLoginForm={this.showSubScripeLoginForm}/>
    <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()}  grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
    </div>
    )

	render() {
        /*require('./ms_main.css');*/
     
        return super.render(
          this.getRouter()
        );	
	  }
	}

export default sg_PreloginHome;

ComponentRegistry.register("sg_PreloginHome",sg_PreloginHome);

/*
* Also registering for the users with hm_ prefix
*/
ComponentRegistry.register("hm_preloginhome",sg_PreloginHome);

/**
* IMPORTANT: Global Prelogin home for SG and other country users
*/
ComponentRegistry.register("PreloginHome",sg_PreloginHome);


// WEBPACK FOOTER //
// ./src/views/sg/sg_PreloginHome.js